import { combineReducers } from "redux";
import AirtimeTokenReducer from "./airtimerokensreducer";

export default combineReducers({
    AirtimeTokenReducer,
});

